<template>
    <div>
        <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.privacy-section-2 class="text-left fw-500">2. Eligibility and Registration</b-button>
            </b-card-header>
            <b-collapse id="privacy-section-2" visible accordion="my-accordion" role="tabpanel">
                <b-card-body>
                    <ol>
                        <li>Eligibility: To be eligible for a VA, the Account Holder must be a resident of any country or a registered business entity worldwide.</li>
                        <li>Registration Process: Registration requires the submission of valid identification and, for businesses, relevant corporate documentation.</li>
                        <li>Approval: RCPAY Virtual Account reserves the right to approve or reject any registration at its discretion without providing reasons.</li>
                        <li>Accuracy of Information: The Account Holder must provide accurate and up-to-date information during registration and maintain it throughout the use of the VA.</li>
                    </ol>
                </b-card-body>
            </b-collapse>
        </b-card>
      
    </div>
</template>

<script>
  
export default {
    name: 'section-2',
    data() {
        return {
        publicPath      : process.env.BASE_URL!='/'?process.env.BASE_URL:''
        };
    }
};
</script>